module.exports = __webpack_public_path__ + "img/usa.a7a6f031.svg";